import { useEffect, useState } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { _TEST1234, SUSPENDED_NOTICE_KEY } from "../config/ApiConfig";
import { LoginForm } from "./Login/LoginForm";
import { LoginHeader } from "./Login/LoginHeader";
import { LoginFooter } from "./Login/LoginFooter";
import { useLogin } from "../authentication/useLogin";
import { IconButton } from "@/comn/components";

const CloseButton = () => {
    const { reset } = useLogin();
    const { t } = useTranslation();
    return (
        <IconButton
            icon="close"
            className="absolute left-full top-0 translate-y-full text-white bg-white/10"
            onClick={reset}
        >
            {t("B_CLS")}
        </IconButton>
    );
};

/**
 * Notice shown on the login screen when a suspended account signs in.
 * !== 정지 계정 로그인 시 로그인 화면에 띄우는 안내. 공통 모달(CommonModal)은 로그인 라우트에
 *     마운트되지 않으므로 이 화면이 자체적으로 그린다. ==!
 */
const SuspendedNotice = ({ onClose }: { onClose: () => void }) => {
    const { t } = useTranslation();
    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40">
            <div className="w-[440px] max-w-[90vw] rounded bg-white shadow-xl">
                <div className="px-6 pt-6 pb-4 whitespace-pre-line text-sm text-black">{t("msg.osc.00323")}</div>
                <div className="flex justify-end px-6 pb-5">
                    <button
                        type="button"
                        autoFocus
                        onClick={onClose}
                        className="h-10 min-w-[96px] rounded-full px-6 text-white text-sm font-bold"
                        style={{ backgroundColor: "#00AD59" }}
                    >
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
};

const Login = (props: any) => {
    const [suspended, setSuspended] = useState(false);

    /**
     * Shows the suspension notice once when redirected here from a suspended sign-in.
     * !== 정지 계정 로그인으로 넘어온 경우 안내를 한 번만 띄운다. 세션은 이미 끊긴 상태다. ==!
     */
    useEffect(() => {
        if (window.sessionStorage.getItem(SUSPENDED_NOTICE_KEY) !== "Y") return;
        window.sessionStorage.removeItem(SUSPENDED_NOTICE_KEY);
        setSuspended(true);
    }, []);

    return (
        <>
            {/* Background Image */}
            {/* <img
                className="w-screen h-screen object-cover"
                src={process.env.PUBLIC_URL + "/imgs/img_login_bg.webp"}
                alt="login background image"
                title="login background image"
            /> */}
            {/* Content */}
            <div
                className={classNames(
                    "fixed overflow-y-auto w-screen h-screen top-0 left-0 flex flex-col items-center",
                    props.type === "tanesw" && "z-[9998]",
                )}
                style={{ backgroundColor: "#F0F4F8" }}
            >
                <div className={classNames("relative py-10 my-auto w-[520px]", "sm:w-[80vw]")}>
                    <LoginHeader />
                    <LoginForm />
                    <LoginFooter />
                </div>
            </div>
            {suspended && <SuspendedNotice onClose={() => setSuspended(false)} />}
        </>
    );
};

export default Login;
